interface CarbonConfidenceBadgeProps {
  level: "alta" | "média" | "baixa";
  showLabel?: boolean;
}

export default function CarbonConfidenceBadge({ level, showLabel = true }: CarbonConfidenceBadgeProps) {
  const config = {
    alta: {
      bg: "bg-primary-50",
      text: "text-primary-700",
      border: "border-primary-200",
      icon: "ri-check-double-line",
      label: "Alta",
    },
    média: {
      bg: "bg-caution-50",
      text: "text-caution-700",
      border: "border-caution-200",
      icon: "ri-alert-line",
      label: "Média",
    },
    baixa: {
      bg: "bg-warning-50",
      text: "text-warning-700",
      border: "border-warning-200",
      icon: "ri-error-warning-line",
      label: "Baixa",
    },
  };

  const c = config[level];

  return (
    <span className={`inline-flex items-center gap-1 px-2 py-1 rounded-md text-xs font-medium border ${c.bg} ${c.text} ${c.border}`}>
      <i className={`${c.icon} w-3.5 h-3.5 flex items-center justify-center`} />
      {showLabel && <span>{c.label}</span>}
    </span>
  );
}